import * as React from "react";
import UnderConstruction from "../../../../../shared/presentations/UnderConstruction";

const TimeOffManagementPage = () => {
  return (
    <div>
      <UnderConstruction></UnderConstruction>
    </div>
  );
};

export default TimeOffManagementPage;
